import { AppForm, AppFormProps } from 'components/organisms';
import { FormNavButtons, SimpleInputElement } from 'components/molecules';
import { settingsTexts, commonTexts } from 'consts/text';
import { MealTypesFormFields } from 'types';
import { IconDeviceFloppy } from '@tabler/icons-react';

export type MealTypeAddEditFormProps = Omit<
    AppFormProps<MealTypesFormFields>,
    'width' | 'title' | 'name' | 'onFinish' | 'error' | 'withGoBack'
> & {
    onFinish: (mealTypeData: MealTypesFormFields) => void;
    axiosError: string | undefined | null;
    isLoading: boolean;
    type: 'add' | 'edit';
};

export const MealTypeAddEditForm = ({
    type,
    initialValues,
    onFinish,
    axiosError,
    ...props
}: MealTypeAddEditFormProps) => {
    const isAddFlow = type === 'add';
    const title = isAddFlow
        ? settingsTexts.mealTypes.addMealType
        : settingsTexts.mealTypes.editMealType;
    const name = isAddFlow ? 'mealTypeAdd' : 'mealTypeEdit';
    const mealTypeAddEditError = axiosError ?? '';
    const buttonText = isAddFlow ? commonTexts.actionLabels.add : commonTexts.actionLabels.save;
    const buttonIcon = isAddFlow ? undefined : <IconDeviceFloppy size={20} />;

    return (
        <AppForm<MealTypesFormFields>
            title={title}
            name={name}
            onFinish={onFinish}
            error={mealTypeAddEditError}
            withGoBack
            {...props}
        >
            <SimpleInputElement
                label={settingsTexts.mealTypes.columnNames.name}
                name="name"
                placeholder="Podaj nazwę"
            />

            <FormNavButtons
                formValuesBeforeChanges={initialValues}
                buttonText={buttonText}
                leftIcon={buttonIcon}
                withPlus={isAddFlow}
            />
        </AppForm>
    );
};
